export default __webpack_public_path__ + "static/media/rbc-logo.67454192.png";